/*
  FLS legal: digital download consent (Consumer Contracts Regulations 2013, reg 37).
  - Saves the tickbox to cart attributes as soon as it changes (so it survives cart re-renders and shows on the order).
  - Blocks every checkout button (cart page, cart drawer, cart pop-up, links to /checkout) until the box is ticked
    when the cart holds a paid digital item (requires_shipping false, price above 0).
*/
(function () {
  if (window.__flsDigitalConsent) return;
  window.__flsDigitalConsent = true;

  var ATTR = 'Digital download consent';
  var ATTR_TIME = 'Digital download consent time';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
  var saving = Promise.resolve();

  function boxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-digital-consent]'));
  }

  function save(checked, value) {
    var attributes = {};
    attributes[ATTR] = checked ? value : '';
    attributes[ATTR_TIME] = checked ? new Date().toISOString() : '';
    saving = fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function (e) {
      console.error('Digital consent save failed', e);
    });
    return saving;
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('.cart__checkout-button[name="checkout"]'));
  }

  function sync() {
    var list = boxes();
    var anyUnticked = list.some(function (b) { return !b.checked; });
    checkoutButtons().forEach(function (btn) {
      var scope = btn.closest('cart-drawer') || btn.closest('#main-cart-footer');
      var box = scope ? scope.querySelector('[data-digital-consent]') : null;
      if (box && !box.checked) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
    // Hide express / accelerated checkout buttons on the cart page while a digital item is in the cart
    var hasBox = list.length > 0;
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (el) {
      el.style.display = hasBox ? 'none' : '';
    });
    return anyUnticked;
  }

  function showError(scope, show) {
    if (!scope) return;
    var wrap = scope.querySelector('[data-digital-consent-wrapper]');
    var err = scope.querySelector('[data-digital-consent-error]');
    if (wrap) wrap.classList.toggle('is-error', !!show);
    if (err) err.hidden = !show;
  }

  function cartNeedsConsent(cart) {
    var needs = (cart.items || []).some(function (i) {
      return i.requires_shipping === false && i.final_line_price > 0;
    });
    var has = cart.attributes && cart.attributes[ATTR];
    return needs && !has;
  }

  function proceed(el) {
    el.setAttribute('data-fls-consent-ok', '1');
    el.click();
    setTimeout(function () { el.removeAttribute('data-fls-consent-ok'); }, 4000);
  }

  function guard(event, el) {
    if (!el || el.getAttribute('data-fls-consent-ok') === '1') return;
    var scope = el.closest('cart-drawer') || el.closest('#main-cart-footer');
    var box = scope ? scope.querySelector('[data-digital-consent]') : null;

    if (box) {
      if (!box.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(scope, true);
        box.focus();
        return;
      }
      // Ticked: make sure the save has finished, then go on.
      event.preventDefault();
      event.stopImmediatePropagation();
      saving.then(function () { proceed(el); });
      return;
    }

    // No box here (e.g. the "added to cart" pop-up): ask the server what's in the cart.
    event.preventDefault();
    event.stopImmediatePropagation();
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartNeedsConsent(cart)) window.location.href = cartUrl + '?digital_consent=1';
        else proceed(el);
      })
      .catch(function () { window.location.href = cartUrl; });
  }

  function checkoutTarget(node) {
    if (!node || !node.closest) return null;
    return node.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
  }

  document.addEventListener('click', function (event) { guard(event, checkoutTarget(event.target)); }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout') guard(event, submitter);
  }, true);

  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!box || !box.matches || !box.matches('[data-digital-consent]')) return;
    boxes().forEach(function (b) { if (b !== box) b.checked = box.checked; });
    var scope = box.closest('cart-drawer') || box.closest('#main-cart-footer');
    if (box.checked) showError(scope, false);
    save(box.checked, box.value);
    sync();
  });

  // Cart sections get re-rendered by the theme; keep button state in line.
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; sync(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function init() {
    sync();
    if (/[?&]digital_consent=1/.test(window.location.search)) {
      var footer = document.getElementById('main-cart-footer');
      showError(footer, true);
      var box = footer && footer.querySelector('[data-digital-consent]');
      if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
